module.exports = require("whatwg-fetch");


//////////////////
// WEBPACK FOOTER
// external "whatwg-fetch"
// module id = 2
// module chunks = 0 1